// GENERATED FILE, PLEASE DO NOT EDIT
export default {
  None: 0,
  Small: 4,
  Medium: 8,
  Large: 16,
  XLarge: 24,
  ButtonDefault: 4,
  FieldsInputDefault: 4,
  FieldsInputConnectedWrapperDefault: 4,
  ModalDefault: 16,
  PaginationDefault: 20,
  PopoverContainerDefault: 4,
  ToastContainer: 24,
  ToggleTypeCheckbox: 4,
  ToggleTypeToggle: 24,
  TooltipContainer: 4,
  TooltipButtonClose: 24
};